import React from 'react';
import PropTypes from 'prop-types';

import { Color, colorList, ComponentSize } from '../../../typings/design-tokens';
import { IComponent } from '../../../typings/generic-component';
import { IClassNames, makeClassNames } from '../../../utils/styles';
import { iconSizeList } from '../icons/icon';
import IconArrowLink from '../icons/icon-arrow-link';
import './arrow-link.scss';

export interface IArrowLink extends IComponent {
  link?: string | null;
  reverse?: boolean;
  onClick?: (id: number | string | undefined) => any;
  id?: number | string;
}

const DEFAULT_ICON_SIZE: ComponentSize = 'xxsmall';
const DEFAULT_ICON_COLOR: Color = 'red-light';

const classNames = (): IClassNames =>
  makeClassNames({
    arrowLink: 'arrow-link',
  });

const ArrowLink = ({
  /* istanbul ignore next: default value */ size = DEFAULT_ICON_SIZE,
  /* istanbul ignore next: default value */ color = DEFAULT_ICON_COLOR,
  /* istanbul ignore next: default value */ reverse = false,
  onClick,
  id,
  link,
}: IArrowLink) => {
  const cn = classNames();

  return link ? (
    <a href={link} className={cn.arrowLink}>
      <IconArrowLink size={size} color={color} reverse={reverse} />
    </a>
  ) : (
    <a className={cn.arrowLink} onClick={() => (onClick ? onClick(id) : undefined)}>
      <IconArrowLink size={size} color={color} reverse={reverse} />
    </a>
  );
};

/* istanbul ignore else */ if (process.env.NODE_ENV !== 'production') {
  ArrowLink.propTypes = {
    color: PropTypes.oneOf(colorList),
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    link: PropTypes.string,
    onClick: PropTypes.func,
    reverse: PropTypes.bool,
    size: PropTypes.oneOf(iconSizeList),
  };
}

export default ArrowLink;
